export function getCssVariableValue(cssVarName: string) {
  return getComputedStyle(document.documentElement).getPropertyValue(cssVarName);
}

export function isYoutubeUrl(url: URL | string) {
  if (!url) return false;

  if (typeof url === 'string') {
    try {
      url = new URL(url);
    } catch (e) {
      return false;
    }
  }

  return url.hostname.includes('youtube');
}

/**
 * Returns the subdomain the
 * current application is hosted
 * on. This parameter can also
 * be specified using a `?subdomain`
 * search parameter
 */

export function getSubdomainParameter(defaultValue = '') {
  const splitted = window.location.hostname.split('.');
  const urlSubdomain = splitted.length >= 3 ? splitted[0] : undefined;
  const searchParams = new URLSearchParams(window.location.search);

  const subdomainSearchParam = searchParams.get('subdomain') ?? '';

  return urlSubdomain || subdomainSearchParam || defaultValue;
}

export * from './qr';
